import {
  Filter
} from '../common/filter';

require('./footer.component.scss');

class FooterController {
  constructor(
    $scope,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    FiltersService,
    CurrentFilterDataService,
    CancelersService,
    LayoutService,
    AggregateDataService,
    ServerInformationService,
    FilterEditorService,
    AdminModalService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.LayoutService = LayoutService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.FiltersService = FiltersService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.CancelersService = CancelersService;
    this.locLabel = Filter.locLabel;
    this.AggregateDataService = AggregateDataService;
    this.ServerInformationService = ServerInformationService;
    this.FilterEditorService = FilterEditorService;
    this.AdminModalService = AdminModalService;
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get hddUsage() {
    return this.ServerInformationService.hddUsage;
  }

  get hddAlarm() {
    return this.ServerInformationService.hddAlarm;
  }

  get databaseAlarm() {
    return this.ServerInformationService.databaseAlarm;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  get isEventsLoading() {
    return this.CurrentFilterDataService.filterData.loading ||
      this.CurrentFilterDataService.filterData.loadingMore ||
      this.FiltersService.loading;
  }

  get isLoading() {
    return this.CurrentModelService.loading ||
      this.currentFilter.imageLoading ||
      this.AggregateDataService.loading ||
      this.AggregateDataService.loadingMore ||
      this.FiltersService.loading ||
      this.LayoutService.loading ||
      this.CurrentFilterDataService.isLoading;
  }

  get databaseUsage() {
    return this.ServerInformationService.databaseUsage;
  }

  reload() {
    window.CACHE.reset();
    this.$rootScope.$broadcast('reload');
  }

  cancel() {
    this.AggregateDataService.cancel();
    this.CurrentFilterDataService.filterData.cancel();
  }

  hddStatus() {
    this.AdminModalService.hddStatus();
  }

  get loadTime() {
    if (this.currentFilter.filter && this.currentFilter.filter.isCardOrDashboard) {
      const dd = this.CurrentFilterDataService.dashboardData;
      const keys = Object.keys(dd);
      let minStart = 0;
      let maxFinish = 0;
      keys.forEach(key => {
        if (dd[key].currentFilterId && dd[key].currentFilterId != this.currentFilter.filter.id) return;
        if (dd[key].startLoad < minStart || !minStart) minStart = dd[key].startLoad;
        if (dd[key].finishLoad > maxFinish || !maxFinish) maxFinish = dd[key].finishLoad;
      });
      return maxFinish > minStart ? Math.round((maxFinish - minStart) / 10) / 100 : 0;
    } else {
      const fd = this.CurrentFilterDataService.filterData;
      return fd.finishLoad > fd.startLoad ? Math.round((fd.finishLoad - fd.startLoad) / 10) / 100 : 0;
    }
  }

  databaseStatus() {
    this.AdminModalService.databaseStatus();
  }

  editQueryFilter() {
    return this.FilterEditorService.editModal({
      filter: this.filter,
      asNew: false,
      selectFilter: false,
      tabName: 'QueryTab',
    });
  }
}

export const FooterComponent = {
  template: require('./footer.component.html'),
  controller: FooterController,
};



// WEBPACK FOOTER //
// ./src/layout/footer.component.js